<template>
  <Transition
    name="details"
    appear
  >
    <div
      class="location-hover-details"
      :style="{ transform: `translate(${x}px, ${y}px)` }"
      v-if="hoveringLocation"
    >
      <div class="wrap">
        <div class="wrap2">
          <div class="country type-body2">{{ hoveringLocation.heading }}</div>
          <div class="address">{{ hoveringLocation.address }}</div>
          <div class="phone">{{ hoveringLocation.phone }}</div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
const props = defineProps({
  locations: {},
})

const emits = defineEmits([])

const { $gsap, $ScrollTrigger } = useNuxtApp()

const { app, debug, browser } = useStores()

const refRoot = ref(null)

const hoveringLocation = computed(() => {
  return props.locations.find((l) => l.id == app.hoverLocation)
})

const link = computed(() => {
  return hoveringLocation.value.href?.url || undefined
})

const { x, y } = useMouse({
  type: "client",
})

const onClick = () => {
  if (!link.value) return
  window.open(link.value, "_blank")
}

watch(
  () => hoveringLocation.value,
  () => {
    if (hoveringLocation.value) {
      window.addEventListener("click", onClick)
      if (link.value) {
        document.body.style.cursor = "pointer"
      }
    } else {
      window.removeEventListener("click", onClick)
      document.body.style.cursor = "default"
    }
  }
)
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";

.location-hover-details {
  position: fixed;
  top: 0;
  left: 0;
  transition: all 0.1s ease 0s;
}

.wrap {
  position: relative;
  z-index: 1000;
  background: linear-gradient(
    180deg,
    #ef9fcc -3.57%,
    #e0a1a3 43.32%,
    #f58556 101.75%
  );
  padding: 1px;
  border-radius: $p1;
  transform: translate(#{$p3}, -100%);
  transform-origin: left center;
}

.wrap2 {
  padding: $p3;
  background: black;
  border-radius: $p1;
}

// .num {
//   margin-top: $p1;
// }

.address,
.phone {
  color: rgba($cl-light, 0.6);
  white-space: pre-line;
}

.address {
  margin-block: $p1;
}

.details-enter-active,
.details-leave-active {
  transition: all 0.3s ease;

  .wrap {
    transition: all 0.3s ease;
  }
}

.details-enter-from,
.details-leave-to {
  .wrap {
    opacity: 0;

    transform: translate(#{$p3}, -100%) scale(0.5);
  }
}
</style>
